// extracted by mini-css-extract-plugin
export default {"community":"styles_community__aOW26","tags":"styles_tags__omHxW","heading":"styles_heading__7oVVb"};